
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es/renting",
      function () {
        return require("private-next-pages/es/renting/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es/renting"])
      });
    }
  